import BrowseEvents from '@ot-modules/Events/Browse'

const EventsAndExhibitionsTab = ({ pageMetaInfo }: { pageMetaInfo?: any }) => (
  // @ts-ignore
  <BrowseEvents
    isEventsModule
    availableFilters={['date', 'sort']}
    defaultRequestFilters={{ ownedOrRelatedToAccount: pageMetaInfo?.accountId }}
    className='gallery-events-browse'
  />
)

export default EventsAndExhibitionsTab
